export const zhS = {
  ADD_COLOR_STRING_KEY: '添加颜色',
  ADD_TEXT_KEY: '添加文本',
  ADD_TO_ORDER_KEY: '加入订单',
  ADD_TO_CART: '添加到购物车',
  ADD_TEMPLATE: '添加模板',
  ADJUST_SIZE_KEY: '调整大小',
  ADJUST_TRANSPARENCY_KEY: '调整透明度',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    '单击“完成”即表示您同意 HP 的使用条款和隐私声明。',
  ALIGN_BOTTOM_KEY: '对齐底部',
  ALIGN_CENTER_KEY: '居中对齐',
  ALIGN_KEY: '对齐',
  ALIGN_LEFT_KEY: '开始',
  ALIGN_MIDDLE_KEY: '对齐中间',
  ALIGN_RIGHT_KEY: '结束',
  ALIGN_TOP_KEY: '顶部对齐',
  ALL_TAB_TITLE_KEY: '全部',
  ALMOST_DONE_TITLE_KEY: '即将完成！',
  AND_KEY: '和',
  APPLY_KEY: '应用',
  AREA_CODE: '区号',

  BASIC_HELPER_INSTRUCTION1_KEY: '浏览内容，并为您的设计选择图像或自行上传图像',
  BASIC_HELPER_INSTRUCTION2_KEY: '预览您的设计，或微调细节',
  BASIC_HELPER_INSTRUCTION3_KEY: '自定义设计，并将其他元素添加到项目',
  BASIC_HELPER_INSTRUCTION4_KEY:
    '设计准备就绪时，单击“下一步”进行最后的检查并下订单。',
  BACK_KEY: '返回',
  BACKGROUND_KEY: '背景',
  BACKGROUND_UPPER_CASE_KEY: '背景',
  BACKGROUND_CONTRAST_KEY: '背景对比度',
  BLANK_INSPIRATION_CATEGORY_KEY: '在此类别下未找到任何灵感',
  BRING_TO_FRONT_KEY: '置于顶层',
  CANCEL_TEXT_KEY: ' 取消 ',
  CENTIMETERS_KEY: '厘米',
  CM_KEY: '厘米',
  CHANGE_YOUR_SETTINGS_KEY: '更改项目设置',
  CHECKBOX_CONTENT1: '我想收到Pattern Design©时事通讯',
  CHECKBOX_CONTENT2: '我授权HP代表我在Pattern Design©服务中创建一个帐户',
  CHOOSE_FROM_COMPUTER_KEY: '从计算机中选择',
  CHOOSE_RIP_OPTIONS: '选择下列兼容的第三方 RIP 之一',
  CHOOSE_FILE_KEY: '选择文件',
  CITY: '市',
  CLEAR_ALL_KEY: '全部清除',
  CLEAR_COLOR_KEY: '清除颜色',
  CLOSE_WINDOW_KEY: '关闭窗口',
  CLEAR_ALL_OBJECTS: '清除所有对象',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE: '将从背景中移除所有对象。',
  CLEAR_DESIGN_KEY: '清除设计',
  COLOR_KEY: '颜色',
  CONTINUE_KEY: '继续...',
  COMPANY: '公司',
  CONGRATULATIONS_KEY: '恭喜！',
  CONFIRM_PASSWORD: '确认密码',
  CONFIRM_PATTERN_ACCOUNT_KEY: '还没有 Pattern Design 帐户？',
  CONFIRM_VECTEEZY_ACCOUNT_KEY: '还没有Vecteezy账号？',
  COUNTRY: '国家',
  CREATE_ACCOUNT: '创建帐号',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: '习惯',
  CUSTOM_PRICE_SIGN_IN_KEY: '在下一步中登录，查看自定义定价。',
  CM_UNIT_KEY: '厘米',
  CREATE_NEW: '新建',
  DESIGN_KEY: '设计',
  DELETE_KEY: '删除',
  DOCUMENT_COLORS: '文件颜色',
  DONE: '完成！',
  DONE_KEY: '完成',
  DONT_SHOW_ALERT_KEY: '不再显示',
  DOWNLOAD_COLUMN_HEADER_KEY: '下载',
  DOWNLOAD_APP_TITLE_KEY: '您可以在此处下载该应用程序：',
  DOWNLOAD_LINK_KEY: '在此处免费下载 HP Click',
  DOWNLOAD_HP_SMARTSTREAM_KEY: '下载 HP SmartStream',
  DOWNLOAD_INSTR_KEY: '在继续之前，请确保您已安装 HP Click',
  DOWNLOAD_SMARTSTREAM_KEY: '下载 HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Dropbox 导入',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    '图像尺寸应小于 1 GB。我们接受 pdf、png、jpg、svg 和 tiff 格式。',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime搜索',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime图像',
  DUPLICATE_KEY: '重复',
  EACH_ITEM_PRICE_KEY:
    '您的设计包含来自我们的一个付费内容提供商的内容。每个元素的分项定价汇总如下。',
  EDIT_DESIGN_BUTTON_TITLE_KEY: '编辑设计',
  EDIT_LOWERCASE_KEY: '编辑',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT: '抱歉，存在错误。请稍后重试。',
  ERROR_IN_OPENING_PDF_FILE_TEXT: '糟糕，打开上传的 PDF 文件时出错。',
  EMAIL_KEY: '电子邮件',
  EMAIL_ADDRESS_KEY: '电子邮件地址：',
  EMAIL_CHECKBOX_MESSAGE:
    '我知道此用户了解将代表我或此服务提供商从 HP 接收电子邮件。',
  EXTRA_INFO_KEY: '额外信息',
  EMAIL_NOTIFICATION:
    '系统稍后会向您发送一封电子邮件。处理过程最多需要 15 分钟。',
  EMAIL_DIALOG_MESSAGE: '请键入您希望与其分享设计的人员的电子邮件地址。',
  ENTER_KEY: '输入',
  EXISTING_FOLDER_KEY: '现有文件夹',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    '在继续结账之前，请确保所有选中的项目均正确无误',
  FINAL_CHECK_TITLE_KEY: '最终检查',
  FINISH_KEY: '完成',
  FINISH_LATER_KEY: '稍后完成',
  FIRSTNAME: '名字',
  FISCAL_NUM: '财政数字',
  FLIP_KEY: '翻转',
  FOR_KEY: '对于',
  FORGOT_PASSWORD_KEY: '忘记密码？',
  FOTOLIA_KEYWORDS_KEY: '关键字：',
  FOLDER_NAME: '文件夹名称',
  FOLDER_NAME_KEY: '文件夹名称：',
  FOLDER_ALREADY_EXIST_KEY: '该文件夹名称已经存在',
  FREE_POSTER_COMPLETE_MESSAGE_KEY: '您刚刚完成了您的免费海报设计',
  FREE_VECTOR_GRAPHICS_KEY: '免费矢量图形',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: '好的，我知道了',
  GROUP_ALL_KEY: '全部进行分组',
  GROUP_SCALE: '分组范围',
  GIFT_WRAPS_KEY: '礼品包装',
  GIVE_PROJECT_NAME_KEY: '为您的项目指定一个名称',
  HEIGHT_KEY: '高度',
  TOUR_DESCRIPTION_TEXT:
    '我们将引导您完成设计过程。请记住，您随时可以通过单击帮助图标重新打开导览。',
  HELP_KEY: '帮助',
  HELPER_TITLE_KEY_1:
    '从空白页面或数百万图像和文本创建海报设计。 从本地驱动器，Dropbox或社交媒体上传您自己的内容',
  HELPER_TITLE_KEY_3: '在一个地方查看您的所有设计工作',
  HELPER_TITLE_KEY_4: '单击“下一步”以预览并完成最终设计',
  HERE_KEY: '此处',
  HELP_IMPROVE_KEY:
    '帮助提高您的工作效率和操作员效率，并通过颜色生成进行扩展。',
  HIGH_QUALITY_KEY: '高品质',
  IMAGES_TITLE_KEY: '图像',
  IMPERIAL_KEY: '帝国',
  IMPORTING_KEY: '正在导入',
  INCHES_COLUMN_HEADER_KEY: '英寸',
  INCHES_KEY: ' 英寸',
  INCHES_UNIT_STRING_KEY: '英寸',
  INVALID_EMAIL_ADDRESS_KEY: '电子邮件地址无效',
  INVALID_INFO_KEY: '请输入详细信息。',
  INVALID_NAME_KEY: '名称无效',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    '抱歉，您选择的文件过大。最大文件大小为 500MB。',
  INSUFFICIENT_CREDITS_KEY: '积分不足',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: '创意作品',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    '糟糕，文件格式无效。我们仅处理 pdf、jpg、png 和 tif。',
  LANDSCAPE_KEY: '横向',
  LANGUAGE_LABLE_KEY: '语言',
  LASTNAME: '姓',
  LEARN_MORE: '了解更多信息',
  LEARN_THE_BASICS_KEY: '了解基本信息',
  LEGAL_FOOTER_MESSAGE1_KEY: '使用此站点即表明您同意遵守相关规定',
  LEGAL_FOOTER_MESSAGE2_KEY: '此网站遵守',
  LEGAL_FOOTER_MESSAGE3_KEY: '和',
  LENGTH_STRING_IN_INCHES_KEY: '英寸',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: '更改',
  LINK_READER_APP_KEY: 'LinkReader 应用程序',
  LINK_READER_APP_DESCRIPTION_KEY:
    '如想可视化您要添加的内容，请下载 LinkReader 应用程序。',
  LOADING_KEY: '正在加载...',
  LOADING_TEMPLATE_KEY: '加载模板',
  LOGIN_NOW: '现在登录',
  LOCK_KEY: '锁定',
  LOGIN_KEY: '登录',
  LOGIN_PATTERN_DESIGN_KEY: '登录 Pattern design',
  LOGIN_SUBTITLE_KEY: '登录以查看自定义定价和付款详细信息',
  LOGIN_VECTEEZY_KEY: '登录 Vecteezy',
  LOGIN_DREAMSTIME_KEY: '登录Dreamstime ',
  LOGOUT_KEY: '注销',
  MATERIAL_TITLE_KEY: '材料',
  MATERIAL_STRING_KEY: '材料',
  MEASUREMENT_KEY: '测量',
  METRIC_KEY: '度量',
  MOBILE: '移动',
  MODEL_TITLE_KEY: '型号',
  MORE_INFO_TEXT_KEY: '更多信息',
  MY_GIFTWRAPS_KEY: '我的礼物包装',
  MY_WORK_KEY: '我的工作',
  MY_WORK_SAVE_KEY: '您的设计已保存到“我的工作”空间',
  NAME_KEY: '名称：',
  NEXT_BUTTON_TITLE_KEY: '下一个',
  NEW_FOLDER_KEY: '新建文件夹',
  NO_SHADOW_KEY: '没有阴影',
  OBJECT_QUANTITY_KEY: '数量',
  OBJECTS_UPPER_CASE_KEY: '对象',
  OK_KEY: '确定',
  ORDER_SAMPLE_KEY: '订购样品',
  ORDER_SAMPLE: '订购样品',
  ORDER_SAMPLE_INFOLABEL_1: '选择您要作为样品订购的图像',
  ORDER_SAMPLE_INFOLABEL_2: '您将收到一封带有实际项目尺寸近摄图的电子邮件',
  ORDER_SAMPLE_INFOLABEL_3: '这将有助于您评估其品质和分辨率',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: '立即订购样品',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    '接收包含项目实际尺寸特写视图的电子邮件以评估其质量/分辨率。',
  ORIENTATION_KEY: '方向',
  OTHER_PRINTING_OPTIONS: '其他打印选项',
  PASSWORD_KEY: '密码',
  PATTERN_COLOR_KEY: '图案颜色',
  PATTERN_DESIGN_TITLE_KEY: '样式设计',
  PATTERNS_FOR_KEY: '图案，',
  PDF_GENERATION_ERROR_MESSAGE_KEY: '生成 PDF 失败。请重试。',
  PHOTOS_KEY: '照片',
  PHOTO: '照片',
  PHONE: '电话',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY: '我拥有此图像的版权并同意',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    '图像尺寸应小于 500 MB。我们接受 png、jpg、tiff、svg 和 pdf 格式。',
  PIXEL_COLUMN_HEADER_KEY: '像素',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: '厘米',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: '在此输入文字...',
  PLACEHOLDER_EXTRA_INFO_KEY: '即您需要传达给打印店的一些重要事项',
  PLACEHOLDER_INCHES_STRING_KEY: '英寸',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: '我的海报',
  PORTRAIT_KEY: '纵向',
  POSITION: '位置',
  PREMIUM_IMAGES_TITLE_KEY: '付费图像：',
  PRE_CHECK_SAVE_DIALOG_TITLE: '保存项目',
  PRE_CHECK_SAVE_DIALOG_MESSAGE: '您的项目具有在继续之前需要保存的更改。',
  PRICE_COLUMN_HEADER_KEY: '价格',
  PRINTER_SERIAL_NUMBER_KEY: '打印机序列号*',
  PRINTING_ENABLE_DETAILS_KEY: '要启用打印，我们只需要更多详细信息',
  PRINTER_MODELS_KEY: '打印机型号*',
  PROCESSING_KEY: '正在处理...',
  PROCESSING_ALERT_TXT: '在我们处理您的设计时，请勿关闭此窗口',
  PROCESSING_ALERT_TXT2: '处理完成后，HP Click 将自动打开并开始下载您的文件',
  PROCESSING_DONE: '您即将完成！',
  PROCESSING_FILE_TXT: '您的文件正在处理中。',
  PROCESSING_TIME_TXT:
    '这可能需要一些时间，因为我们正在编辑您的创意以确保最佳图像质量',
  PROCESSING_ALERT_TXT3: '您的 PDF 将自动下载到您的计算机',
  PROCESSING_ALERT_TXT4: '请记住，您可以在设置中配置 JDF 连接以实现自动化',
  PREMIUM_CONTENT_KEY: '付费内容',
  PREVIEW_KEY: '预览',
  PROFESSIONAL_USE_TITLE_KEY: '可供专业人士使用。',
  PROJECT_NAME_KEY: '项目名称',
  PROJECT_NAME: '项目名称：',
  PROJECT_ALREADY_EXIST_KEY: '该对象名称已经存在',
  NONUNIQUE_PROJECT_NAME_MESSAGE: '该对象名称已经存在',
  NONUNIQUE_FOLDER_NAME_MESSAGE: '该文件夹名称已经存在',
  PIXELATION_WARNING_KEY: '像素化警告',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    '由于您上传照片的分辨率，您的皮肤可能会变形或扭曲。为确保没有模糊，请上传高质量的图像并避免图像拉伸。如果您对预览满意并希望继续，请继续提交。',
  REGISTER_CONTACTINFO: '联系信息',
  REGISTER_INFO: '注册信息',
  REGISTER_PATTERNSUB1: '作为HP客户的价值，',
  REQUIRED_FIELDS_KEY: '必填字段',
  REQUIRED_FIELDS_TEXT_KEY: '必填字段',
  REQUIRED_STRING_KEY: '必填',
  RECOLOR_KEY: '重新上色',
  RADICALLY_SIMPLE_KEY: '极其简单的打印软件',
  RIPSELECTION_HEAD: '这是您第一次打印，请选择您首选的兼容打印软件',
  RIPSELECTION_DESC:
    '您的选择将成为未来打印输出的默认打印选项路径。以后可以在设置中进行更改',
  REGISTER_COMPANYINFO: '公司信息',
  REGISTER_KEY: '注册',
  REGISTER_NOW: '立即注册',
  REOLOR_KEY: '重新上色',
  REQUEST_SAMPLE_KEY: '索取样品',
  RESIZE_KEY: '调整大小',
  RESIZE_ARBITRARILY_KEY: '任意调整大小',
  RESIZE_PROPORTIONALLY_KEY: '按比例调整大小',
  REVIEW_AND_SUBMIT_KEY: '审核并提交',
  REQUEST_FOR_QUOTATION: '报价请求',
  RIGHT_LOGO_TEXT_KEY: '签字',
  ROTATE_KEY: '旋转',
  ROTATE_LEFT_KEY: '向左旋转 90°',
  ROTATE_RIGHT_KEY: '向右旋转 90°',
  ROTATION_KEY: '旋转',
  ROWS_COLUMN_LABEL_STRING_KEY: '行和列',
  ROYALTY_FREE_KEY: '免版税的',
  ROYALTY_KEY: '王权',
  SALUTATION: '招呼',
  SAVE_KEY: '保存',
  SAVING_KEY: '正在保存...',
  SAVE_INSPIRATION: '保存创意作品',
  SAVE_TEMPLATE: '保存模板',
  SAVE_DIALOG_TITLE: '保存项目',
  SAVE_PROJECT_NAME_KEY: '先保存项目',
  SAVEDIALOG_MESSAGE:
    '请登录以保存项目。如果您没有帐户，我们将帮助您创建一个。您的进度不会丢失。',
  SEAMLESS_KEY: '无缝',
  SCALE_INFO_STRING_KEY: '缩放图像以适合您的设计',
  SCALE_KEY: '缩放',
  SCALE_ALL_KEY: '全部缩放',
  SCALE_TO_FILL_KEY: '缩放以填充',
  SEARCH_BUTTON_TITLE_KEY: '搜索',
  SELECT_CUSTOM_SIZE_KEY: '选择自定义大小',
  SELECT_CUSTOM_KEY: '习惯',
  SEARCH_TITLE: '搜索',
  SELECTED_IMAGE_KEY: '选定的图像：',
  SELECT_GIFT_WRAPS_SIZE_KEY: '选择礼品包装尺寸',
  SELECT_COUNTRY: '选择国家',
  SELECT_SALUTATION: '---选择---',
  SELECT_POSTER_SIZE_KEY: '选择海报大小',
  SELECT_PRINTING_OPTION_KEY: '选择您的首选打印选项',
  SEND_INSTALLATION_INSTRUCTION_KEY: '向我发送安装说明',
  SEND_TO_BACK_KEY: '置后',
  SEND_KEY: '发送',
  SEND_TO_PRINT_TITLE_KEY: '发送到打印',
  SET_SIZE_KEY: '设置尺寸',
  SETTINGS_KEY: '设置',
  SETTINGS_UPPERCASE_KEY: '设置',
  SHARE_KEY: '共享',
  SIGNED_IN_AS_KEY: '登录身份',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY: '登录或注册以查看自定义定价和付款详细信息',
  SIGN_UP_NOW_KEY: '立即注册',
  SKIP_KEY: '跳过',
  SOLID_COLORS_KEY: '纯色',
  SQFT_UNIT_STRING_KEY: '平方英尺',
  SQM_UNIT_STRING_KEY: '平方米',
  START_TOUR_KEY: '开始导览',
  STATUS_MSG: '您的文件已发送到打印！',
  SUBMIT_BUTTON_KEY: '提交',
  SHARE_LINK_LABEL: '选择要共享的链接类型',
  SHARE_EDIT_LINK: '编辑链接',
  SHARE_VIEW_LINK: '查看链接',
  SHARE_YOUR_CREATION: '分享您的创意！',
  STREET_ADD: '街道地址',
  TARGET_VIEWING_HINT: '* 目标查看距离可以在设置中更改。',
  TERMS1_KEY: '条款',
  TERMS2_KEY: 'HP 隐私声明',
  TERMS3_KEY: 'HP 个人数据权利声明',
  TERMS_OF_USE_KEY: '使用条款',
  TERMS_OF_USE: '使用条款。',
  TEXT_SHADOW_COLOR_KEY: '文字阴影颜色',
  TEXT_ANCHOR_MIDDLE: '中间',
  TEXT_UPPERCASE_KEY: '文本',
  TILE_KEY: '平铺',
  TOTAL_KEY: '总计',
  TOTAL_PRICE_KEY: '总计:',
  TRANSPARENCY_KEY: '透明度',
  TEMPLATES_KEY: '模板',
  TEMPLATES_UPPER_CASE_KEY: '模板',
  THANK_YOU_KEY: '谢谢',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: '解锁',
  UNGROUP_KEY: '取消分组',
  UPDATE_TEXT_KEY: '更新',
  UPLOAD_KEY: '上传',
  UPLOAD_LOGO_KEY: '上传徽标',
  UPLOAD_IMAGE_KEY: '上传您自己的图像',
  UPLOAD_UPPERCASE_KEY: '上传',
  USER_NAME: '用户名',
  USER_TYPE_TITLE_KEY: '您是哪种类型的用户*',
  UNTILE_KEY: '取消平铺',
  UNSPLASH_SEARCH_TITLE: 'Unsplash 搜索',
  VALIDITY_KEY: '有效期',
  VANILLA_LOGIN_DIALOG_KEY: '免费加入以保存和打印您的设计并查看您保存的工作',
  VANILLA_PREVIEW_MESSAGE_KEY:
    '这是您的设计预览，请在确认设计是最终版之后继续，或选择编辑以进行任何更改',
  VAT_KEY: '增值税',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: '矢量',
  VIEW_FOTOLIA_KEY: '在 Fotolia© 中查看',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: '查看设计细节',
  VIEW_DESIGNER_PROFILE_KEY: '查看 Designer 配置文件',
  VIEW_PRICE_KEY: '查看价格',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy 搜索',
  WALL_POSTER_KEY: '海报',
  WALL_SIZE_TEXT_KEY: '墙壁尺寸',
  WARNING_KEY: '警告',
  WEBSITE: '网站',
  WIDTH_KEY: '宽度',

  YOU_CAN_ALWAYS_ACCESS: '您可以随时在下列位置访问您的设计 ',
  YOUR_NAME_KEY: '您的名字',
  YOUR_SELECTION_WILL_KEY: '您的选择将成为未来打印输出的默认打印路径。',
  YOUR_PROJECT_KEY: '您的项目：',
  PROJECT_NAME_ERROR_TEXT: '请为您的项目输入名称。',
  PROJECT_FOLDER_ERROR_TEXT: '请为您的项目文件夹输入名称。',
  PIXELATION_WARNING_SETTINGS_KEY: '像素警告设置',
  MINIMUM_VIEWING_DISTANCE_KEY: '最小查看距离',
  BACKGROUND_UPLOAD_KEY: '背景',
  OBJECT_UPLOAD_KEY: '对象',
  PHOTO_UPLOAD_KEY: '照片',
  NO_DREAMSTIME_ERROR_MESSAGE: '找不到dreamtime内容',
  NO_ELEMENT_ERROR_MESSAGE: '未找到任何元素。',
  NO_MORE_IMAGES_FOUND_KEY: '找不到更多图片',
  NO_PATTERN_ERROR_MESSAGE: '未找到图案。',
  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  ALREDY_HAVE_AN_ACCOUNT: '已经有了 a {0} 帐户？',
  CHANGE_MEASURING_SYSTEM_KEY: '更改为 {0}',
  DOWNLOADS_KEY: '{0} 下载',
  HEX_COLOR_KEY: '六角色：{0}',
  NEAR_KEY: '近',
  FAR_KEY: '远',
  CLOSE_UP_KEY: '特写',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    '您尝试使用的图像要么小于或大于您使用的设计区域。',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    '要获得更好的效果，请使用999分辨率的图像',
  MESSAGE_KEY: '消息：',
  VIEWS_KEY: '{0} 意见',
  COST_DESCRIPTION_MESSAGE_KEY:
    '这是与您设计中包含的付费内容相关的成本摘要。{0} 选择“完成”即表示您同意由内容提供商收取以下费用。',
  DEFAULT_PRINTING_OPTION_KEY: '{0} 是您的默认打印选项，',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' 你将修改价值100美元的高分辨率图像 {0} 帮助满足您的所有创意需求！',
  REGISTER_PATTERNSUB3:
    '立即注册并在接下来的30天内，从我们2500万张照片的内容库中下载创意文件，看看如何 {0} 可以帮助您满足您的创意需求。',
  ZOOM_WARNING_PIXELATED_TEXT:
    '您已经缩放到打印的图像以 {0} {1} *（当前打印分辨率为 {2}dpi）查看时可能会出现像素化现象的程度。',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    '建议的查看距离应为 {0} {1}。如果此距离不合适，请缩小此图像的比例或墙壁尺寸。',
  ZOOM_WARNING_VALID_IMAGE_TEXT: '推荐的最小图像大小应为 {0} x {1} 像素。',
  UPLOAD_STATUS: '{0}%/{1} MB',
  REGISTER_TO: '注册 {0}',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MINIMUM_DIMENSIONS_KEY: '最小尺寸为 {0}（宽）乘以 {1}（高）。',
  MINIMUM_HEIGHT_KEY: '最小高度为 {0}。',
  MINIMUM_WIDTH_KEY: '最小宽度为 {0}。',
  MAXIMUM_DIMENSIONS_KEY: '最大尺寸为 {0}（宽）x {1}（高）。',
  MAXIMUM_WIDTH_KEY: '最大宽度为 {0}。',
  MAXIMUM_HEIGHT_KEY: '最大高度为 {0}。',
  INVALID_NUMBER_ERROR_TEXT_KEY: '请插入尺寸（大于零的数值）。',
  PROCESSING_FAILED: '处理失败，请稍后再试。',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT: '抱歉，不支持多页 PDF。',
  MINIMUM_ZOOM_WARNING:
    '无法进一步缩小该背景，因为已达到用于覆盖墙壁所需的最小高度或宽度。',
  OF_KEY: '的',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT: '抱歉，不支持加密的PDF。',
  DROPBOX_UPLOAD_PROGRESS_KEY: '正在导入第 {0} 个文件（共 {1} 个）',
  RECOLORING_KEY: '正在重新上色...',
  TEXT_COLOR_KEY: '文本颜色',
  SOLID_COLOR_KEY: '纯色',
  MATERIAL_CHOICE_APPLIED: '应用材料选择.',
  AUTHENTICATE_DIALOG_TITLE: '此内容源受密码保护',
  AUTHENTICATE_FAILED_MESSAGE: '身份验证失败！',
  DROPBOX_IMPORT_ERROR_HEADER: '导入某些文件时出现问题',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  INSPIRATION_SIZE_CHANGE_WARNING:
    '该灵感模板的默认大小为{0} X {1} {2}。 您的页面大小将自动更改以适合此模板。',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: '项目',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: '选择你的笔记本',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: '请输入必填字段',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: '你的资料',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: '注意：',
  CAUTION_FOR_LAPTOP_SELECTION:
    '为了使PC皮肤完全适合您，您必须选择与所购买产品相对应的确切型号，如发票所示。',
  RESTART_PROJECT_ALERT_TITLE: '重新启动项目？',
  DISCARD_ALERT_MESSAGE: '您当前的项目将被放弃',
  RESTART: '重新启动',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: '证书',
  AUTHENTICITY_STRING: '真伪',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: '页面大小警告！',
  MODIFY_SIZE_WARNING:
    '如果您希望调整此设计的大小，可以在“设置”选项卡中进行。 设计元素可能需要进行编辑以适应所需的尺寸。',
  RANDOMIZE_KEY: '隨機化',
  PLEASE_WAIT: '请耐心等待',
  PROTECTING_YOUR_DATA: '保护您的数据...',
  SEARCH_YOUR_LAPTOP_KEY: '搜索您的笔记本电脑', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY: '糟糕！ 我们找不到适合您搜索的笔记本电脑。', // Google translated
  SERIAL_NUMBER_KEY: '序列号',
  LOCKED_PROJECT: '锁定的项目',
  LOCKED_MESSAGE: '已订购此项目，无法更改。您只能查看此项目。 ',
  EXPIRED_PROJECT: '过期的项目',
  EXPIRED_MESSAGE: '此项目已过期。',
  DELETED_PROJECT: '删除的项目',
  DELETED_MESSAGE: '此项目已删除。',
  CHOOSE_GROUP_TYPE: '选择 {0} 类型',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: '请输入大于零的数字。',
  SIZE_KEY: '尺寸',
  DISTANCE_FROM_KEY: '距离',
  MYROOM_UPPERCASE_KEY: '我的房间',
  FURNITURE_KEY: '家具',
  FIXTURES_KEY: '固定装置',
  ADD_A_WALL_KEY: '添加墙壁',
  SELECT_A_WALL_KEY: '选择墙壁',
  LEFT_KEY: '左',
  RIGHT_KEY: '右',
  DELETE_WALL_KEY: '删除墙壁',

  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: '选择画布类型',
  MAXIMUM_WALL_SIZE_KEY: '最大墙壁尺寸为 {0} 平方 {1}。',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY: '画布高度超过了墙壁高度。',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY: '画布宽度超过了墙壁宽度。',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY: '当前宽度的最大列数为 {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY: '当前高度的最大行数为 {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY: '墙壁宽度小于画布宽度。',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY: '墙壁最小宽度应为 {0} {1}。',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY: '墙壁最小高度应为 {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    '墙壁高度小于画布高度。',
  MAXIMUM_WALL_HEIGHT_KEY: '最大墙壁高度为 {0} {1}.',
  FINISHING_KEY: '表面整饰',
  MIRROR_KEY: '镜面',
  NATURAL_KEY: '自然',
  ROWS_KEY: '行',
  COLUMNS_KEY: '列',
  DEFAULT_WALL_SIZE_KEY: '默认墙壁尺寸',
  EDIT_KEY: '编辑',
  TOP_KEY: '顶部',
  BOTTOM_KEY: '底部'
};
